<template>
  <v-card>
    <v-card-title>
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Search"
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>
    <delete-dialog
      @success="deleteClass"
      :confirm-loading="deleteConfirmLoading"
      @closeDialog="cancelDelete"
      :dialog="delete_dialog"
      title="Class"
    ></delete-dialog>

    <v-data-table
      :loading="loading"
      :items="items"
      :headers="headers"
      :search="search"
    >
      <template v-slot:item.id="{ item }">
        <span class="table-tutor-srno">{{ item.id }}</span>
      </template>
      <template v-slot:item.subjects="{ item }">
        <v-chip v-for="subject in item.class_subject_group" :key="subject.id">{{
          subject.subject.subject_name
        }}</v-chip>
      </template>
      <template v-slot:item.action="{ item }">
        <router-link
          class="profile-link"
          active-class
          :exact="true"
          :to="{ name: 'EditClass', params: { id: item.class_id } }"
        >
          <v-icon color="success">mdi-file-edit</v-icon>
        </router-link>
        <v-icon color="red" @click.stop="confirmDelete(item)"
          >mdi-delete</v-icon
        >
      </template>
    </v-data-table>
    <!-- <div class="pa-2 d-flex justify-end">
      <span class="pa-2">
        Total Classes
        <span
                :style="{'color':this.$vuetify.theme.themes.light.primary}"
        >{{count}}</span>
      </span>
            <v-spacer></v-spacer>
            <v-pagination circle v-model="page" :length="totalPages"></v-pagination>
        </div> -->
  </v-card>
</template>

<script>
import DeleteDialog from "../Dialogs/DeleteDialog";
import DataTableMixin from "../../mixins/dataTable";
import DeleteRow from "../../mixins/deleteRow";

export default {
  name: "ClassTable",
  components: {
    DeleteDialog,
  },
  mixins: [DataTableMixin, DeleteRow],
  data() {
    return {
      search: null,

      loading: true,
      headers: [
        { text: "SrNo.", sortable: true, value: "class_id" },
        { text: "Class", value: "class_name", sortable: true },
        // {text: "Subjects", value: "subjects", sortable: false},
        { text: "Subject", value: "subjects", sortable: false },

        { text: "Total Fare", value: "fare_per_hour", sortable: true },
        { text: "Class Code", value: "class_code", sortable: true },
        { text: "Action", value: "action", sortable: false },
      ],
    };
  },
  methods: {
    deleteClass() {
      this.deleteConfirmLoading = true;
      axios
        .delete(apiRoutes.classes.url + "/" + this.current_row.class_id)
        .then((response) => {
          // console.log(response)
          this.getItems();
          this.deleteConfirmLoading = false;
          this.delete_dialog = false;
        })
        .catch((error) => {});
    },
    getZeroAddedNum(num) {
      return num.toString().padStart(2, "0");
    },
    getItems() {
      this.loading = true;
      axios
        .get(apiRoutes.classes.url, { params: this.formQueryParams() })
        .then((response) => {
          // console.log(response)
          this.formalizeTable(response.data);
          this.loading = false;
        });
    },
  },
  mounted() {
    this.getItems();
  },
};
</script>

<style lang='scss'>
.v-data-table-header th span {
  font: 300 14px Gotham;
  font-family: "Gotham Narrow";
  color: #8898aa;
}

.table-tutor {
  &-srno {
    font: 500 14px/13px Gotham;
    color: #172b4d;
  }

  &-name {
    display: block;
    font: 500 14px/13px Gotham;
    color: #6a158e;
  }

  &-email {
    font: 400 12px/13px Lato;
    color: #172b4d4d;
  }

  &-time {
    display: block;
    font: 400 11px/10px Lato;
    color: #0e0edff7;
  }

  &-days {
    font: 400 10px/15px Lato;
    color: #172b4db3;
  }

  &-tutor {
    font: 500 13.5px Gotham;
    color: #529b11;
  }
}

.v-btn.v-size--default {
  font-size: 12px;
  text-transform: none;
}
</style>